import kebabCase from "lodash/kebabCase";

import { MASTER_COMPANY_TYPENAME } from "@stadium/shared/src/constants/templates-listing";

export const getFormattedSlug = (slug) => kebabCase(slug);

export const isMasterCompany = (type) => type === MASTER_COMPANY_TYPENAME;

export const getCategoryId = ({ categories = [], name }) => {
  if (categories?.length) {
    return categories.find(({ name: categoryName }) => name === categoryName.toLowerCase())?.id;
  }
  return "";
};
